import React, { Component } from "react";
import Modal from "react-modal";
import axios from "axios";
import "../common.css";
import Select from "react-select";
import LoadingPage from "../../components/Loading/Loading";
import config from "../../config";
import errorFunctions from "../../store/errorFunctions";
import "./StaffAdd.css";

import utilityFunctions from "../../store/utilityFunctions";
Modal.setAppElement("body");

const roleOptions = [
  { label: "Commercial Admin", value: "Commercial Admin" },
  { label: "Commercial Staff", value: "Commercial Staff" },
];

export default class StaffEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isLoading: false,
      details: this.props.user,
      id: null,
      showApproveModal: false,
      showDeclineModal: false,
      addComment: "",
      startPostageNumber: "",
      endPostageNumber: "",
      showDeleteModal: false,
      redirect: false,
      showOutOfWarrantyModal: false,
      showAddNote: false,
      addedNote: "",
      employee: null,
      ticketID: null,
      employeeID: null,
      showAssignModal: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      currentRole: this.props.user.user_role,
      name: "",
      email: "",
      storeLocationLabel:
        this.props.user.seller.name +
        " - " +
        this.props.user.store_location.name,
      storeLocationChanged: false,
    };
  }

  componentDidMount() {
    this.retriveAllBrand();
    // this.retriveAllRoles();
    this.retrieveStoreLocation();
  }

  retrieveStoreLocation = () => {
    this.setState({
      isLoading: true,
      // deviceId: brandDevice[0]?.id,
    });
    this.props
      .protectedFetch(
        config.backendServer + "store_locations/",
        "GET",
        { country: config.country },
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const options = res.map((r) => {
          return { label: r.seller_name + " - " + r.name, value: r.id };
        });

        this.setState({
          sellers: res,
          filteredSellers: res,
          isLoading: false,
          locationOptions: [...[{ label: "---", value: "" }], ...options],
          selectedSeller: options.find((s) => s.value === res[0].id),
          // stores: res[0].store_locations,
          // deviceId: brandDevice[0]?.id,
        });
        // this.props.retrieveStore(res[0].id);
      })
      .catch((err) => console.log(err));
  };
  // retriveDetailStaff = (id) => {
  //   this.setState({ loading: true });
  //   this.props
  //     .protectedFetch(config.backendServer + "employee/" + id + "/", "GET", { id }, errorFunctions.checkResponseThenJson)
  //     .then((res) => {
  //       this.setState({ loading: false, details: res, currentRole: res.user_role });
  //     })
  //     .catch(() => {
  //       console.log("fail");
  //       this.setState({ loading: false });
  //     });
  // };

  retriveAllBrand = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "brands/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, brands: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };
  deleteUserLocation = () => {
    let url = `${config.backendServer}store_location/${this.state.currentStoreLocationId}/remove_staff/${this.state.details.id}/`;
    const userInfo =
      localStorage.getItem("userInfo") ||
      utilityFunctions.getCookie("userInfo");
    const token = userInfo?.access_token || JSON.parse(userInfo)?.access_token;
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    fetch(url, options).then((response) => {
      console.log(response.status);
      if (response.status === 204) {
        this.setState({ showConfirmDelete: false, loading: false });
        if (this.state.storeLocationId)
          this.addUserLocation(this.state.details.id);
      } else if (response.status === 406) {
        alert(
          `Delete is not allowed, User Service Center is already linked to ticket`
        );
      } else if (response.status === 409) {
        alert(`User Service does not exist.`);
      } else {
        alert("Problem with system. Please refresh and try again later.");
      }
    });
  };
  addUserLocation = (userId) => {
    this.setState({ loading: true });
    if (!userId && !this.state.storeLocationId) {
      alert("User is not selected");
      return;
    }
    let payload = {
      employee_id: this.state.details.id,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .post(
        `${config.backendServer}store_location/${this.state.storeLocationId}/add_staff/`,
        payload,
        options
      )
      .then(() => {
        // let tempUsers = [...this.state.data];
        // tempUsers.push(res.data);
        this.setState({ loading: false, showAddUser: false, employeeID: "" });
        this.props.retrieveStaffs();
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
        //   resolve(err);
      });
  };
  handleSubmit = () => {
    this.setState({ loading: true });

    const id = this.props.user.id;
    const selectedBrandIds = Array.from(
      document.querySelectorAll("input[type='checkbox']:checked")
    ).map((checkbox) => parseInt(checkbox.value));

    let payload = {
      brands: selectedBrandIds,
      name: this.state.name ? this.state.name : this.state.details.name,
      email: this.state.email ? this.state.email : this.state.details.email,
      user_role: this.state.currentRole
        ? this.state.currentRole
        : this.state.details.user_role,
    };

    this.props
      .protectedFetch(
        config.backendServer + `employee/${id}/`,
        "PUT",
        payload,
        errorFunctions.checkResponseThenJson
      )
      .then(() => {
        if (
          this.state.storeLocationChanged &&
          this.state.currentStoreLocationId
        )
          this.deleteUserLocation();
        else if (this.state.storeLocationChanged && this.state.storeLocationId)
          this.addUserLocation(this.state.details.id);
        this.setState({
          name: "",
          email: "",
          currentRole: "",
          loading: false,
          redirect: true,
        });
        this.props.closeModal();
      })
      .catch(() => {
        console.log("fail");
      });
  };
  handleRole = (e) => {
    this.setState({ currentRole: e.target.value });
  };
  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  render() {
    if (this.state.loading) {
      return <LoadingPage />;
    }

    const details = this.props.user || {};
    const locValue = this.state.locationOptions?.find(
      (loc) => loc.label === this.state.storeLocationLabel
    );

    return (
      <div className="card">
        <h4 className={"card-header"}>{details.name}</h4>
        <form onSubmit={this.handleSubmit}>
          <div className="card-body">
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>
                Full name:
              </label>
              <input
                type="text"
                id="name"
                required={true}
                defaultValue={details.name || this.state.fullName}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>Email:</label>
              <input
                type="email"
                id="email"
                required={true}
                defaultValue={details.email || this.state.email}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>Brands:</label>
              <span>
                {this.state.brands.map((brand) => (
                  <div className="col-6" key={brand.id}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`brand-${brand.id}`}
                        defaultChecked={this.state.details.brands.some(
                          (activeBrand) => activeBrand.id === brand.id
                        )}
                        value={brand.id}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`brand-${brand.id}`}
                      >
                        {brand.name}
                      </label>
                    </div>
                  </div>
                ))}
              </span>
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>Role:</label>
              <Select
                required
                options={roleOptions}
                value={roleOptions.find(
                  (x) => x.value === this.state.currentRole
                )}
                placeholder="Select Role"
                onChange={(e) => {
                  this.setState({
                    currentRole: e.value,
                  });
                }}
                // onInputChange={(val) => this.searchLocationState(val)}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>
                Store Location<span>:</span>
              </label>
              <Select
                required
                options={this.state.locationOptions}
                value={locValue}
                placeholder="Select Location"
                isLoading={this.state.isLoading}
                onChange={(e) => {
                  const curStoreLocId =
                    this.state.locationOptions.find(
                      (l) => l.label === this.state.storeLocationLabel
                    )?.value || "";
                  this.setState({
                    currentStoreLocationId: curStoreLocId,
                    storeLocationId: e.value,
                    storeLocationLabel: e.label,
                    storeLocationChanged: curStoreLocId !== e.value,
                  });
                }}
                // onInputChange={(val) => this.searchLocationState(val)}
              />
            </div>
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="col-3">
                <button className={"btn btn-outline-primary"} type="submit">
                  Save
                </button>
              </div>
              <div className="col-3">
                <button
                  className={"btn btn-outline-secondary"}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.closeModal();
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
